import { SignUp } from "@clerk/clerk-react";
import { clerkConfig } from "../config/clerk";

export default function SignUpPage() {
  return (
    <div className="flex-1 flex">
      <div className="m-auto w-full max-w-md p-4 sm:px-6 lg:px-8">
        <SignUp 
          appearance={clerkConfig.appearance}
          routing="path"
          path="/sign-up"
          afterSignUpUrl={clerkConfig.afterSignUpUrl}
          signInUrl="/sign-in"
        />
      </div>
    </div>
  );
} 